import { Link } from "@tanstack/react-router";

export function NotFoundPage(): JSX.Element {
  return (
    <div className="onboarding-shell">
      <div className="onboarding-card" data-testid="not-found">
        <div>
          <h1>Not found</h1>
          <p>The page you requested does not exist or you do not have access.</p>
        </div>
        <Link to="/dashboard" className="btn btn-primary">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}
